"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const list_component_1 = require("../list/list.component");
const selectOption_component_1 = require("./selectOption.component");
const selectGroupOption_component_1 = require("./selectGroupOption.component");
class SelectOptionsList extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.renderSingleItem = (info) => {
            return (react_1.default.createElement(selectOption_component_1.SelectOption, { item: info.item, multi: this.props.multiSelect, selected: this.props.isOptionSelected(info.item), disabled: info.item.disabled, onSelect: this.props.onSelect }));
        };
        this.renderGroupItem = (info) => {
            return (react_1.default.createElement(selectGroupOption_component_1.SelectGroupOption, { item: info.item, multi: this.props.multiSelect, isOptionSelected: this.props.isOptionSelected, onSelect: this.props.onSelect }));
        };
        this.renderItem = (info) => {
            return this.props.isOptionGroup(info.item) ? this.renderGroupItem(info) : this.renderSingleItem(info);
        };
    }
    render() {
        return (react_1.default.createElement(list_component_1.List, { style: this.props.style, bounces: false, data: this.props.data, renderItem: this.renderItem }));
    }
}
exports.SelectOptionsList = SelectOptionsList;
//# sourceMappingURL=selectOptionsList.component.js.map